import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qcontent-detail';

const ELEMENTS = define({
  HEADER_MENU: ['header', 'menu'],
  STATUS_TAG: ['status', 'tag'],
  ITEM_SET_HEADER_MENU: ['item-set-header', 'menu'],
  ITEM_SET_STATUS_TAG: ['item-set-status', 'tag'],
});

export const QCONTENT_DETAILS_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
